<template>
    <div>
        <!-- <div class="top-div">
            <div class="item">
                <el-button size="mini" type="warning" icon="el-icon-upload" @click="uploadXML">导入XML</el-button>
            </div>
            <div class="item">
                <el-button size="mini" type="primary" icon="el-icon-download" @click="exportFilterTXT">导出TXT</el-button>
            </div>
            <div class="item">
                <span class="label-span">舰船型号:</span>
                <el-radio v-model="radio" label="054A">054A</el-radio>
                <el-radio v-model="radio" label="052C">052C</el-radio>
                <el-button size="mini" type="primary" icon="el-icon-download" @click="exportFilterXML">导出XML</el-button>
            </div>

        </div> -->
        <el-tabs class="base-tabs" type="border-card">
            <el-tab-pane label="故障位置">
                <faultLocationCom />
            </el-tab-pane>
            <el-tab-pane label="故障现象">
                <faultPheon />
            </el-tab-pane>
            <el-tab-pane label="故障器材">
                <div class="lonTree-div listTable">
                    <div class="margins">
                        <span>
                            <el-button class="base-button" size="mini" type="primary" icon="el-icon-plus" @click="addMaintenance">新增</el-button>
                        </span>
                        <span>
                        </span>
                    </div>
                    <YzTable :columnApi="columns" :afterRequest="afterRequest" :listApi="listArray" :searchForm="searchForm"
                        :autoLoad="true" ref="YzTable" />
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import faultLocationCom from './faultLocation/index.vue'
import faultPheon from './faultPheon/index.vue'
import addCom from "./maintenance/add.vue"
import uploadXMLCom from "./uploadXML/index.vue"
import { getCommonAjax } from "@/api/common"
export default {
    components: {
        faultLocationCom,
        faultPheon
    },
    data() {
        return {
            radio:'054A',
            searchForm: {},
            listArray: "/wx/queryWxqcList",
            columns: "json/maintenance.json?v=2",
        };
    },

    mounted() {
        this.$bus.$on("maintenance-list", () => {
            this.handleFilter();
        });
    },
    beforeDestroy() {
        this.$bus.$off("maintenance-list");
    },
    methods: {
        exportFilterTXT() {
            getCommonAjax("/wx/downloadtxt", {}, "arraybuffer").then(res => {
                this.downloadJsonFile(res, '装备字典数据_' + new Date().getTime() + ".txt")
            }).catch(err => {
                console.error(err);
            });
        },
        exportFilterXML() {
            getCommonAjax("/wx/downloadxml?type="+this.radio,{}, "arraybuffer").then(res => {
                this.downloadJsonFile(res, '装备字典数据_' + new Date().getTime() + ".xml")
            }).catch(err => {
                console.error(err);
            });
        },
        downloadJsonFile(data, fileName) {
            var blob = new Blob([data], { type: 'application/octet-stream' });
            var url = URL.createObjectURL(blob);
            var link = document.createElement('a');
            link.download = fileName;
            link.href = url;
            link.click();
            URL.revokeObjectURL(url);
        },
        handleFilter() {
            this.searchForm.page = 1;
            this.$refs["YzTable"].getList(this.searchForm, true);
        },
        uploadXML(){
            this.$dialog.open({
                title: "装备字典导入",
                theme: "feature-dialog",
                shade: true,
                area: {
                    height: "380px",
                    width: "680px",
                },
                content: {
                    type: "vue",
                    subCom: uploadXMLCom,
                    subData: {}
                },
            });
        },
        addMaintenance() {
            this.$dialog.open({
                title: "新增维修器材",
                theme: "feature-dialog",
                shade: true,
                area: {
                    height: "350px",
                    width: "680px",
                },
                // location: {
                //     top: "100px",
                // },
                content: {
                    type: "vue",
                    subCom: addCom,
                    subData: this.subData
                },
            });
        },
        afterRequest(res) {
            return {
                result: {
                    items: res.result,
                    total: 0
                }
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.top-div {
    display: flex;
    margin: 0 20px 20px 20px;
    color:#fff;
    .item {
        padding: 8px 40px;
        display: flex;
        align-items: center;
        border: solid 1px #3AB0E3;
        margin: 0 20px 0 0;
    }
    .label-span{
        font-size: 14px;
        margin-right: 20px;
    }
}

.lonTree-div {
    height: 560px;
    position: relative;
    z-index: 9;
    overflow-y: auto;
}
</style>